import { DATA_PUBLISH_DOI_LINK } from "@/src/constant/constant";
export const getDoiLink = (doi: string) => {
  return `${DATA_PUBLISH_DOI_LINK}/${doi.trim()}`;
};
